import React from 'react';

const ChromeDevToolsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="40.8 145.43 327.74 415.403"
        >
            <path
                fill="#abadad"
                d="M354.157 522.753h-96.818v24.08h96.818z"
                transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
            ></path>
            <g>
                <path
                    fill="#e14c40"
                    d="M305.637 413.599s82.026 3.692 125.5-78.741H298.664s-25.017.822-46.346-29.53c-6.149-12.716-12.71-25.841-5.329-51.675-10.664 18.042-56.599 98.018-56.599 98.018s32.402 58.649 115.247 61.928"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
                <path
                    fill="#ffd24d"
                    d="M426.864 204.302S389.04 131.43 295.91 135.01c11.49 19.885 66.251 114.714 66.251 114.714s13.222 21.252-2.387 54.897c-7.936 11.687-16.02 23.933-42.087 30.464 20.964.206 113.186-.014 113.186-.014s34.58-57.39-4.009-130.77"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
                <path
                    fill="#00aa60"
                    d="M184.997 203.746s-44.197 69.203 5.476 148.06l66.21-114.742s11.794-22.075 48.74-25.38c14.087 1.028 28.732 1.904 47.42 21.21-10.3-18.254-56.61-98.013-56.61-98.013s-66.988-1.249-111.236 68.865"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
                <path
                    fill="#fff"
                    d="M243.23 273.111c0 34.273 27.786 62.063 62.066 62.063 34.278 0 62.061-27.79 62.061-62.063 0-34.283-27.783-62.069-62.061-62.069-34.28 0-62.066 27.786-62.066 62.07"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
                <path
                    fill="#577fc0"
                    d="M256.628 273.111c0 26.875 21.79 48.665 48.668 48.665 26.87 0 48.664-21.79 48.664-48.665 0-26.879-21.793-48.668-48.664-48.668-26.878 0-48.668 21.79-48.668 48.668"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
                <path
                    fill="#d6483e"
                    d="M305.636 413.599s54.153 2.437 97.777-40.864c-.717 0-148.96-.477-196.584-.477 17.225 17.243 48.842 39.362 98.807 41.34"
                    transform="matrix(1.33333 0 0 -1.33333 -191.281 729.11)"
                ></path>
            </g>
        </svg>
    );
};

export default ChromeDevToolsIcon;